<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="ac-header">
        Cancel invite for {{ selectedTech.firstName }} {{ selectedTech.lastName }}?
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="deactivate"
      >
        Confirm
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
    />
  </div>
</template>

<script>
import technicianMixin from '@shared/mixins/technicianMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'CancelTechnicianConfirm',
  components: {
    ProcessOverlay,
  },
  mixins: [technicianMixin],
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    async deactivate() {
      this.processing = true;
      await this.$store.dispatch('deactivateTech');
      this.processing = false;
      this.toggleActionModal(false);
    },
  },
};
</script>
